// Despesas Gerais (Gestão Orçamentária): novo modelo simples de item ("faixas por período"),
// padrão Custos Gerais por Projeto — ver constants/custosGeraisProjeto.js. Diferença: aqui não
// existe conceito de projeto, então só "quantidade_usuarios" é liberado como tipo de lançamento
// exclusivo (não existe "alocacao_projeto"). Espelha
// backend/services/gestao_orcamentaria_svc.py _tipos_permitidos_despesa, mantenha em sincronia.
export const CODIGO_CATEGORIA_ASSINATURAS_DESPESA = "2.6.11";

export const TIPOS_LANCAMENTO_DESPESA_OPTIONS = [
  { value: "valor_manual", label: "Valor bruto (manual)", descricao: "Só o valor, digitado direto — ex: uma assinatura fixa." },
  { value: "quantidade_usuarios", label: "Quantidade de usuários", descricao: "Valor unitário × nº de usuários, preenchido manualmente." },
];

export function tiposPermitidosParaCategoriaDespesa(categoria) {
  if (!categoria) return ["valor_manual"];
  if (categoria.codigo === CODIGO_CATEGORIA_ASSINATURAS_DESPESA) return ["valor_manual", "quantidade_usuarios"];
  return ["valor_manual"];
}

export function categoriaEhEspecialDespesa(categoria) {
  return tiposPermitidosParaCategoriaDespesa(categoria).length > 1;
}
